const WISHLIST_KEY = 'wishlist-items';

/* ---------- GET WISHLIST ---------- */
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

/* ---------- SAVE WISHLIST ---------- */
function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
}

/* ---------- TOGGLE ITEM ---------- */
function toggleWishlist(handle) {
  let items = getWishlist();

  if (items.includes(handle)) {
    items = items.filter(i => i !== handle);
  } else {
    items.push(handle);
  }

  saveWishlist(items);
}

/* ---------- BUTTON CLICK ---------- */
document.addEventListener('click', function (e) {

  const btn = e.target.closest('.tps__product-wishlist-js');
  if (!btn) return;

  e.preventDefault();

  const handle = btn.dataset.productHandle;
  if (!handle) return;

  toggleWishlist(handle);

  btn.classList.toggle('active');
});

/* ---------- MARK ACTIVE ON LOAD ---------- */
document.addEventListener('DOMContentLoaded', () => {

  const items = getWishlist();

  document.querySelectorAll('.tps__product-wishlist-js').forEach(btn => {

    const handle = btn.dataset.productHandle;

    if (items.includes(handle)) {
      btn.classList.add('active');
    }

  });

});